import { render, staticRenderFns } from "./deleteReason.vue?vue&type=template&id=29077f24&"
import script from "./deleteReason.vue?vue&type=script&lang=js&"
export * from "./deleteReason.vue?vue&type=script&lang=js&"
import style0 from "./deleteReason.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports